"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_1 = require("./parts/form");
var SampleReduxContainer = (function (_super) {
    __extends(SampleReduxContainer, _super);
    function SampleReduxContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SampleReduxContainer.prototype.render = function () {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(form_1.FormReduxComponent, null)));
    };
    return SampleReduxContainer;
}(react_1.Component));
exports.SampleReduxContainer = SampleReduxContainer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2FtcGxlUmVkdXhDb250YWluZXIuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9yZWR1eC9zYW1wbGUvc2FtcGxlUmVkdXhDb250YWluZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBeUM7QUFDekMscUNBQWtEO0FBRWxEO0lBQTBDLHdDQUFTO0lBQW5EOztJQVFBLENBQUM7SUFQRyxxQ0FBTSxHQUFOO1FBQ0ksT0FBTSxDQUNGO1lBQ0ksOEJBQUMseUJBQWtCLE9BQUUsQ0FDbkIsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQUNMLDJCQUFDO0FBQUQsQ0FBQyxBQVJELENBQTBDLGlCQUFTLEdBUWxEO0FBUlksb0RBQW9CIn0=